import React, { useState } from "react";
import "../../../../../css/CashflowModeller2/Inputs/SaveButton.css";

/**
 * SaveButton component renders a customizable button with optional tooltip and active/disabled states.
 *
 * @param {Object} props - The props for the SaveButton component.
 * @param {string} props.buttonText - The text to display on the button.
 * @param {boolean} props.isActive - Determines if the button is in an active (clicked) state.
 * @param {function} props.onClick - Callback function to handle button click events.
 * @param {boolean} props.disabled - If true, the button is disabled and not clickable.
 * @param {boolean} [props.showTooltip=false] - If true, displays a tooltip on hover.
 * @param {React.ReactNode} props.children - Optional children to render inside the button.
 * @returns {JSX.Element} The rendered SaveButton component.
 */
const SaveButton = ({
  buttonText,
  isActive,
  onClick,
  disabled,
  showTooltip = false,
  children,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="tooltip-button-wrapper">
      <div
        className={`SaveButton ${isActive ? "clicked" : ""} ${
          disabled ? "disabled" : ""
        }`}
        onClick={onClick}
      >
        <div className="Label">{buttonText}</div>
      </div>
    </div>
  );
};

export default SaveButton;
